export default "__VITE_ASSET__DN0VAc7i__"